module.exports = __webpack_public_path__ + "static/img/no-image.443bd16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-image.png
// module id = 1193
// module chunks = 1 6 7 8